import { handleOpenPdf } from "utils";
import { LinkButton } from "components/buttons";
import { ASSETS_BASE_URL } from "constants";

function FatcaCrs() {
  return (
    <>
      <div className="container page">
        <h1 className="page-title">FATCA/CRS</h1>

        <p className="page-subtitle">
          The Foreign Account Tax Compliance Act (FATCA) enacted by the United
          States of America (U.S.) is intended to curb tax evasions by U.S.
          persons holding financial accounts outside U.S. The first reporting
          under FATCA takes effect on June 2017. The Common Reporting Standard
          (CRS) on the other hand is part of a global standard proposed by the
          OECD, for the annual cross border exchange of information on financial
          accounts. The first reporting is due on June 2018. Because CRS shares
          a lot of similarities with FATCA, ARBM has introduced the FATCA/CRS
          form that is required to be completed by all existing and new
          customers of the bank.
          <br></br>
          <br></br>
          For more information / other related forms on FATCA, please click{" "}
          <span
            onClick={() => {
              handleOpenPdf(
                "https://www.irs.gov/businesses/corporations/foreign-account-tax-compliance-act-fatca"
              );
            }}
          >
            here
          </span>
          .<br></br>
          <br></br>
          For more information on CRS please refer to this{" "}
          <span
            onClick={() => {
              handleOpenPdf(
                "http://www.oecd.org/tax/automatic-exchange/common-reporting-standard/"
              );
            }}
          >
            FAQ
          </span>
          .<br></br>
        </p>

        <div className="link-button-row">
          <LinkButton
            text={"FAQ on FACTA/CRS"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/CRS_FAQ.pdf`)}
          />
          <LinkButton
            text={
              "Appendix 9 - FATCA/CRS Controlling Person Self-Certification Form"
            }
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/CRS_Appendix9.pdf`)}
          />
          <LinkButton
            text={"Appendix 8 - FATCA/CRS Entities Self Certification Form"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/CRS_Appendix8.pdf`)}
          />
          <LinkButton
            text={"Appendix 7 - FATCA/CRS Individual Self Certification Form"}
            onClick={() => handleOpenPdf(`${ASSETS_BASE_URL}assets/pdf/corporate-governance/CRS_Appendix7.pdf`)}
          />
        </div>
      </div>
    </>
  );
}

export default FatcaCrs;
